import script from "./houseSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./houseSearch.vue?vue&type=script&setup=true&lang=js"

import "./houseSearch.vue?vue&type=style&index=0&id=2c8aaa76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8aaa76"]])

export default __exports__